import React from "react";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";
import FormInput from "Common/Custom/FormInput";
import FormSubmitButton from "Common/Custom/FormSubmitButton";

// Uses `fields` prop from parent — does not re-import JSON directly
const EditBookingForm = ({
    fields = [],
    values,
    errors,
    handleChange,
    handleSubmit,
    loading,
    title = "Edit Booking Type",
}) => {
    return (
        <PageBody
            headerchildren={<HeadingOne>{title}</HeadingOne>}
            onSubmit={handleSubmit}
        >
            {fields.map((field) => (
                <FormInput
                    key={field.name}
                    field={field}
                    value={values[field.name]}
                    handleChange={handleChange}
                    error={errors[field.name]}
                />
            ))}

            <FormSubmitButton
                label="Update Booking Type"
                loading={loading}
                colSize="col-12"
                align="end"
            />
        </PageBody>
    );
};

export default EditBookingForm;
